module.exports = __webpack_public_path__ + "static/media/project-5.3ea7fd9a.png";